import AccenturePngPath from '../media/partnerIcons/Accenture_logo.png';
import DaletPngPath from '../media/partnerIcons/Dalet-Icon-Blue.png';
import AwsSvgPath from '../media/partnerIcons/aws.svg';
import MicrosoftAzureSvgPath from '../media/partnerIcons/azure.svg';
import EZDrmSvgPath from '../media/partnerIcons/ezdrm.svg';
import GoogleCloudSvgPath from '../media/partnerIcons/google_cloud.svg';
import GoogleDfpSvgPath from '../media/partnerIcons/google_dfp.svg';
import IrdetoSvgPath from '../media/partnerIcons/irdeto.svg';
import NagraSvgPath from '../media/partnerIcons/nagra.png';
import UnifiedStreamingSvgPath from '../media/partnerIcons/unified_streaming.svg';
import VerimatrixPngPath from '../media/partnerIcons/verimatrix.png';
import VimondPngPath from '../media/partnerIcons/vimond.png';
import YospaceSvgPath from '../media/partnerIcons/yospace.svg';
import ZixiSvgPath from '../media/partnerIcons/zixi.svg';

interface IPartner {
  name: string;
  logoPath: string;
}

const PartnerData: IPartner[] = [
  {
    name: 'AmazonWebSerices',
    logoPath: AwsSvgPath
  },
  {
    name: 'Accenture',
    logoPath: AccenturePngPath
  },
  {
    name: 'Dalet',
    logoPath: DaletPngPath
  },
  {
    name: 'EZDrm',
    logoPath: EZDrmSvgPath
  },
  {
    name: 'GoogleCloud',
    logoPath: GoogleCloudSvgPath
  },
  {
    name: 'GoogleDFP',
    logoPath: GoogleDfpSvgPath
  },
  {
    name: 'Irdeto',
    logoPath: IrdetoSvgPath
  },
  {
    name: 'MicrosoftAzure',
    logoPath: MicrosoftAzureSvgPath
  },
  {
    name: 'Nagra',
    logoPath: NagraSvgPath
  },
  {
    name: 'Unified Streaming',
    logoPath: UnifiedStreamingSvgPath
  },
  {
    name: 'Verimatrix',
    logoPath: VerimatrixPngPath
  },
  {
    name: 'Vimond',
    logoPath: VimondPngPath
  },
  {
    name: 'Yospace',
    logoPath: YospaceSvgPath
  },
  {
    name: 'Zixi',
    logoPath: ZixiSvgPath
  }
];

export default PartnerData;
